import { Box, styled, useTheme } from '@mui/material';

export const CustomSelect = styled(Box)((props) => ({
	'& .MuiFormLabel-root': {
		color: props.theme.palette.root.basicDeeoGreen,
	},
	'& .MuiOutlinedInput-root': {
		width: '100%',
		'& .MuiSelect-select, & .MuiOutlinedInput-notchedOutline': {
			width: '100%',
			padding: '8px',
			paddingRight: '32px',
			borderRadius: '8px',
			//borderColor: props.theme.palette.root.mediumGreen,
		},

		'& legend': {
			display: 'none',
		},
	},
}));

export const CustomTextField = styled(Box)((props) => ({
	'& .MuiAutocomplete-root': {
		'& .MuiFormLabel-root.MuiInputLabel-shrink': {
			overflow: 'auto',
			display: 'flex',
			alignItems: 'flex-start',
			top: '0px !important',
			//right: '0',
			transformOrigin: 'left center !important',
		},
	},
	'& .MuiTextField-root': {
		'& .MuiFormLabel-root': {
			color: props.theme.palette.root.basicDeeoGreen,
			fontFamily: 'RubikRegular',
		},
		'& .MuiFormHelperText-root': {
			fontFamily: 'RubikRegular',
			fontSize: props.theme.typography.semiCaption.fontSize,
		},
		'& .MuiFilledInput-root': {
			'&:after': {
				borderBottom: 0,
			},
			border: '1px solid ' + props.theme.palette.root.darkGrayed,
			'&.Mui-error': {
				border: '1px solid red',
				backgroundColor: props.theme.palette.error.light,
			},
			borderRadius: '8px',
			backgroundColor: 'inherit',
			'&:before': {
				zIndex: '-1',
			},
		},
		'& .MuiOutlinedInput-root': {
			//width: 'fit-content',
			'& input': {
				padding: '8px',
			},
		},
		'& .Mui-disabled': {
			backgroundColor: props.theme.palette.root.basic6,
			borderRadius: '8px',
		},
		'& .MuiAutocomplete-input': {
			width: '100%',
		},
		'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
			border: '1px solid #3DB37B',
		},
	},
	'& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
		display: 'none',
	},
	'& input[type=number]': {
		MozAppearance: 'textfield',
	},
	'& .searchNav': {
		'& > *': {
			'& .MuiInputBase-root': {
				padding: 0,
				'&.Mui-focused fieldset': {
					borderColor: props.theme.palette.root.brandSecondary,
					borderWidth: '1px',
				},
			},
			animation: 'Effect .6s',
			'@keyframes Effect': {
				'0%': {
					opacity: 0,
				},
				'100%': {
					opacity: 1,
				},
			},
			'& input': {
				padding: '8px',
				width: '260px!important',
				animation: 'Effect .4s',
				'@keyframes Effect': {
					'0%': {
						opacity: 0,
					},
					'100%': {
						opacity: 1,
					},
				},
			},
			'& legend': { display: 'none' },
			'& label': { display: 'none' },
			'& fieldset': { top: 0 },
		},
	},
}));

export const CustomCheckbox = styled(Box)((props) => ({
	'& .MuiCheckbox-root': {
		width: '16px',
		//color: props.theme.palette.root.basicDeeoGreen,
		'&:hover': {
			backgroundColor: 'transparent',
		},
	},
	'& .Mui-checked:after': {
		border: '6px solid #fff',
		borderRadius: '8px',
		height: '32px',
		width: '32px',
		content: '" "',
		opacity: 0.8,
		position: 'absolute',
	},
	'& .Mui-checked svg': {
		backgroundColor: '#fff',
		'& path': {
			fill: props.theme.palette.root.orange,
		},
	},
}));

export const CustomTextArea = styled(Box)((props) => ({
	'& .MuiTextField-root': {
		height: props.theme.sizes.CARD_TEXTAREA,
		overflowY: 'auto',
		'& .MuiFormLabel-root': {
			color: props.theme.palette.root.basicDeeoGreen,
			fontFamily: 'RubikRegular',
		},
		'& .MuiFormHelperText-root': {
			fontFamily: 'RubikRegular',
			fontSize: props.theme.typography.semiCaption.fontSize,
		},
		'& .MuiFilledInput-root': {
			height: props.theme.sizes.CARD_TEXTAREA,
			overflowY: 'auto',
			alignItems: 'start',
			'&:after': {
				borderBottom: 0,
			},
			border: '1px solid ' + props.theme.palette.root.darkGrayed,
			'&.Mui-error': {
				border: '1px solid red',
				backgroundColor: props.theme.palette.error.light,
			},
			borderRadius: '8px',
			backgroundColor: 'inherit',
			'&:before': {
				zIndex: '-1',
			},
		},
		'& .Mui-disabled': {
			backgroundColor: props.theme.palette.root.basic6,
			borderRadius: '8px',
		},
		'& input': {
			top: '0!important',
		},
	},
	'& .css-4qqxcp-MuiInputBase-root-MuiFilledInput-root': {
		overflow: 'auto',
		top: '0!important',
		display: 'flex',
		alignItems: 'flex-start',
	},
}));
type DivProps = {
	isBalancesReport?: any;
	isInFuture?: boolean;
};
export const CustomDateRangePicker = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'isBalancesReport' && prop !== 'isInFuture',
})<DivProps>(({ isBalancesReport, isInFuture }) => {
	const theme = useTheme();
	return {
		'& .rdrDateRangePickerWrapper, & .rdrCalendarWrapper': {
			padding: '32px',
			'& .rdrStaticRange': {
				display: isBalancesReport || isInFuture ? 'none' : 'unset',
				height: '28px',
				padding: '0 12px',
				marginRight: '8px',
				marginBottom: '24px',
				borderRadius: '16px',
				border: 'solid 1px #cbdcde',
				backgroundColor: '#fff',
				fontFamily: 'RubikRegular',
				fontSize: '12px',
				color: theme.palette.root.basicDeepBlue + '!important',
				'&.rdrStaticRangeSelected': {
					backgroundColor: theme.palette.root.brandPrimary_008 + '!important',
					borderColor: theme.palette.root.brandSecondary + '!important',
				},
			},
			'& .rdrDateRangeWrapper, & .rdrMonthAndYearWrapper': {
				position: 'relative',
			},
			'& .rdrInputRanges, & .rdrDateDisplayWrapper, & .rdrMonthAndYearPickers': {
				display: 'none',
				position: 'relative',
			},
			'& .rdrMonthsHorizontal': {
				display: 'flex',
				justifyContent: 'space-between',
			},
			'& .rdrDays': {
				width: '200px',
				display: 'flex',
				flexWrap: 'wrap',
				gap: '2px',
				'& .rdrDay': {
					width: '26px',
					height: '26px',
					textAlign: 'center',
					border: '0',
					background: 'none',
					color: theme.palette.root.basicDeepBlue + '!important',
					fontFamily: 'RubikRegular',
					'&:has(.rdrInRange), &.rdrDayToday': {
						backgroundColor: theme.palette.root.brandPrimary_008 + '!important',
					},
					' &:has(.rdrStartEdge) , &:has(.rdrEndEdge), &:has(.rdrSelected)': {
						backgroundColor: theme.palette.root.brandSecondary + '!important',
						color: '#ffffff!important',
						borderRadius: '50%',
						'& .rdrDayNumber > span': {
							color: '#ffffff!important',
						},
					},
					'&.rdrDayActive': {
						backgroundColor: theme.palette.root.brandSecondary + '!important',
						color: '#ffffff!important',
						borderRadius: '50%',
						'& .rdrDayNumber > span': {
							color: '#ffffff!important',
						},
					},
					'&.rdrDayDisabled': {
						opacity: 0.5,
					},
				},
			},
			'& .rdrWeekDays': {
				fontSize: '12px',
				gap: '2px',
				display: 'flex',
				'& .rdrWeekDay': {
					width: '26px',
					textAlign: 'center',
					fontFamily: 'RubikRegular!important',
				},
			},
			'& .rdrMonthName': {
				textAlign: 'center',
				color: theme.palette.root.basicDeepBlue + '!important',
				fontFamily: 'RubikRegular',
				marginBottom: '16px',
			},
			'& .rdrNextPrevButton': {
				backgroundColor: '#fff',
				position: 'absolute',
				height: '25px',
				'&.rdrNextButton': {
					left: 0,
					border: 'none',
					background: 'url(/icons/icons-chevron-right.svg) center center',
				},
				'&.rdrPprevButton': {
					border: 'none',
					background: 'url(/icons/icons-chevron-left.svg) center center',
				},
			},
		},
	};
});

export const ErrorLabel = styled(Box)((props) => ({
	color: 'red',
	fontSize: '11px',
}));
